import { appstr } from "./appstr";
import { appstrp } from "./appstrp";

export interface BoxLayoutExitAlertConfig {
  header: string;
  message: string;
  saveConfirmStr: string;
  saveDenyStr: string;
  discardConfirmStr: string;
  discardDenyStr: string;
}

export function getBoxLayoutExitAlert(
  editBoxStyleMode: boolean,
  affectedCount: number
): BoxLayoutExitAlertConfig {
  if (!editBoxStyleMode) {
    return {
      header: appstrp("Apply layout changes", "?"),
      message: appstr("Would you like to apply layout changes"),
      saveConfirmStr: appstr("Apply layout changes"),
      saveDenyStr: appstr("Discard Changes"),
      discardConfirmStr: appstr("Discard Changes"),
      discardDenyStr: appstr("Keep editing")
    };
  }

  // "All views using this box style / these box styles will be updated" — plural
  // once more than one box style carries pending edits.
  return {
    header: appstrp("Save layout changes", "?"),
    message:
      affectedCount > 1
        ? appstr("Would you like to save layout changes plural")
        : appstr("Would you like to save layout changes"),
    saveConfirmStr: appstr("Save layout changes"),
    saveDenyStr: appstr("Discard Changes"),
    discardConfirmStr: appstr("Discard Changes"),
    discardDenyStr: appstr("Keep editing")
  };
}
